import { render, staticRenderFns } from "./Fullmenu.vue?vue&type=template&id=19bb6711&scoped=true&"
import script from "./Fullmenu.vue?vue&type=script&lang=js&"
export * from "./Fullmenu.vue?vue&type=script&lang=js&"
import style0 from "./Fullmenu.vue?vue&type=style&index=0&id=19bb6711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb6711",
  null
  
)

component.options.__file = "Fullmenu.vue"
export default component.exports